"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PastDueBanner = PastDueBanner;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@iconify/react");
var react_router_dom_1 = require("react-router-dom");
var routes_1 = require("../../constants/routes");
var hooks_1 = require("../../store/hooks");
var use_has_permission_1 = require("../../utils/use-has-permission");
var text_component_1 = require("../ui/text-component");
function PastDueBanner() {
    var billingStatus = (0, hooks_1.useAppSelector)(function (state) { var _a; return (_a = state.client.client) === null || _a === void 0 ? void 0 : _a.billingStatus; });
    var canManageBilling = (0, use_has_permission_1.useHasPermission)("manage_billing");
    if (billingStatus !== "PAST_DUE" || !canManageBilling)
        return null;
    return ((0, jsx_runtime_1.jsxs)("div", { className: "flex items-center gap-2 bg-amber-100 px-6 py-2 text-sm text-amber-800", children: [(0, jsx_runtime_1.jsx)(react_1.Icon, { icon: "solar:danger-circle-linear", fontSize: 18 }), (0, jsx_runtime_1.jsx)(text_component_1.TextComponent, { size: "small", color: "amber-800", label: "Your subscription payment is failing." }), (0, jsx_runtime_1.jsx)(react_router_dom_1.Link, { to: routes_1.ROUTES.BILLING_SETTINGS, className: "font-medium underline", children: "Update your card" })] }));
}
